import Kampos from 'kampos/src/kampos';
import brightnessContrast from 'kampos/src/effects/brightness-contrast';
import hueSaturation from 'kampos/src/effects/hue-saturation';
import duotone from 'kampos/src/effects/duotone';
import transparentVideo from './effects/transparent-video';

export default {
    effects: {
        brightnessContrast,
        hueSaturation,
        duotone,
        transparentVideo
    },
    Kampos
};
